import { render, staticRenderFns } from "./YingyouTab.vue?vue&type=template&id=2dddbc33&scoped=true&"
import script from "./YingyouTab.vue?vue&type=script&lang=js&"
export * from "./YingyouTab.vue?vue&type=script&lang=js&"
import style0 from "./YingyouTab.vue?vue&type=style&index=0&id=2dddbc33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dddbc33",
  null
  
)

export default component.exports